export default __webpack_public_path__ + "static/media/businessModelMapping.6813ef7b.svg";